// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__1nox3","categories__body":"Categories_categories__body__9aa9P","categories__body1":"Categories_categories__body1__JVXhn"};